import "./Footer.css";

import {
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
} from "react-icons/fa";

import Logo from "../../assets/logos/logo_blanco_v++.svg"

function Footer() {

    return (

        <footer className="footer">

            <div className="footer-container">

                <div className="footer-brand">

                    <img
                        src={Logo}
                        alt="Logo"
                        className="footer-logo"
                    />

                    <p>
                        Transformamos ideas en experiencias digitales mediante
                        creatividad, innovación y tecnología.
                    </p>

                </div>

                <div className="footer-social">

                    <h3>Síguenos</h3>

                    <div className="social-icons">

                        <a href="https://www.facebook.com/Vemasmasmx/?locale=es_LA" target="_blank">
                            <FaFacebookF />
                        </a>

                        <a href="https://www.instagram.com/vemasmasmx/" target="_blank">
                            <FaInstagram />
                        </a>

                        <a href="https://mx.linkedin.com/company/vemasmas" target="_blank">
                            <FaLinkedinIn />
                        </a>

                    </div>

                </div>

            </div>

            <div className="footer-bottom">

                © {new Date().getFullYear()} Empresa. Todos los derechos reservados.

            </div>

        </footer>

    );

}

export default Footer;
